

import { APP_KEY } from '../../../constants/dropbox';
import { Button } from 'antd';
import { config } from '../../../config';
import { log } from '../../log';
import { useState } from 'react';
import { AsyncSVG } from '../AsyncSVG';

/**
 * @todo: check this file in order to do a real refactor.
 */
export default function DropboxChooser({
    buttonBackground,
    children,
    disabled,
    extensionsArray,
    multiselect,
    onFilesDownloaded,
    onError
}) {
    const DROPBOX_SDK_URL = 'https://www.dropbox.com/static/api/2/dropins.js';

    const [isDropboxScriptLoaded, setIsDropboxScriptLoaded] = useState(document.body.children.dropboxjs !== undefined );

    /**
     * This has been created in order to do not require permissions in firefox because when the click is being triggered programmatically
     * the browser ask to the user
     */
    // const isFirstRender = useRef(true);
    // useEffect(() => {
    //     if (isFirstRender.current && !isDropboxScriptLoaded) {
    //         isFirstRender.current = false;
    //         loadDropboxScript();
    //     }
    // }, []);

    /**
     * If it's not disabled and It's not ssrMode:
     *  - Check if the script is loaded
     *      - Case true I open up the dropbox pop-up
     *      - Case false I load the script function
     *
     * @returns void
     */
    const onChoose = async () => {
        if (config.ssrMode !== 1 && !disabled) {
            if (!isDropboxScriptLoaded) {
                await loadDropboxScript()
            }
            openPopup();
        }
    }

    const onCancel = () => {
        log('dropbox cancel');
    }

    const openPopup = () => {
        try {
            window.Dropbox.choose({
                success: onSuccess,
                cancel: onCancel,
                linkType: "direct",
                multiselect: multiselect,
                extensions: extensionsArray
            });
        } catch {
            //Do nothing, try / catch block is to prevent console.error to be called
        }
    }

    const onSuccess = (files) => {
        var fileToUpload = [];
        for (let i = 0; i < files.length; ++i) {
            fileToUpload.push({
                uri: files[i].link,
                fileName: files[i].name
            });
        }
        onFilesDownloaded(fileToUpload);
    }

    /**
     *  Try to load dropbox script and when is ready I trigger the isDropboxScriptLoaded change to true
     */
    const loadDropboxScript = async () => {
        if (!isDropboxScriptLoaded) {
            const resp = await fetch(DROPBOX_SDK_URL);
            const scriptContent = await resp.text();
            const script = document.createElement("script");
            script.innerText = scriptContent;
            script.setAttribute("id", 'dropboxjs');
            script.setAttribute("data-app-key", APP_KEY);
            document.body.appendChild(script);

            setIsDropboxScriptLoaded(true);
        }
    }

    return (
        <Button aria-label="Dropbox" onClick={onChoose} className={`action-button ${buttonBackground}`}>
            <span>
                <AsyncSVG className="cloud-upload-icon" src="/images/upload-dropbox.svg" />
                {children}
            </span>
        </Button>
    )
}
